import React from 'react'
import styled from 'styled-components'

import { Heading1, Heading1Styles, Heading2, Heading3, Heading4, Heading5, Paragraph } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const TopHeading1 = styled.div`
  ${Heading1Styles}
`

const TopHeading2 = styled.div`
  margin-bottom: 32px;
  ${Heading1Styles}
  font-family: 'Maison Neue Mono', sans-serif;
`

const Subheading = styled(Heading4)`
  margin-top: 48px;
  margin-bottom: 16px;
`

const Text = styled(Paragraph)`
  margin-bottom: 48px;
`

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 88px;
  border-bottom: 1px solid #e6e3f4;
`

const Heading1Mobile = styled.div`
  font-size: 29px;
  line-height: 148%;
  font-weight: 500;
  letter-spacing: 0.5px;
`

const Heading2Mobile = styled.div`
  font-size: 26px;
  line-height: 164%;
  font-weight: 500;
  letter-spacing: 0.5px;
`

const Heading3Mobile = styled.div`
  font-size: 23px;
  line-height: 164%;
  font-weight: 500;
  letter-spacing: 0.5px;
`

const Heading4Mobile = styled.div`
  font-size: 20px;
  line-height: 164%;
  font-weight: 500;
  letter-spacing: 0.5px;
`

const Heading5Mobile = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 164%;
  letter-spacing: 0.25px;
`

const ParagraphMobile = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 172%;
  letter-spacing: 0.25px;
`

const Typography = () => {
  return (
    <>
      <Heading>Typography</Heading>
      <TopHeading1>Maison Neue</TopHeading1>
      <TopHeading2>Maison Neue Mono</TopHeading2>
      <Text>
        Our brand typeface for body copy and small text is Maison Neue and Maison Mono. It's a digital-first face with
        loads of personality and a lovely mono to match, working well in both print and digital applications. Depending
        on the application, Maison Neue can also be used for subheadings.
      </Text>
      <Subheading>Scale</Subheading>
      <Text>
        Our typescale is based on the Major Third (1.25 ratio) for desktop and Major Second (1.125 ratio) for mobile,
        with a 16px base size. Please see below line heights.
      </Text>
      <Subheading>Desktop</Subheading>
      <Item>
        <Heading1>Heading 1 desktop</Heading1>
        <p>49px/132%</p>
      </Item>
      <Item>
        <Heading2>Heading 2 desktop</Heading2>
        <p>39px/140%</p>
      </Item>
      <Item>
        <Heading3>Heading 3 desktop</Heading3>
        <p>31px/148%</p>
      </Item>
      <Item>
        <Heading4>Heading 4 desktop</Heading4>
        <p>25px/156%</p>
      </Item>
      <Item>
        <Heading5>Heading 5 desktop</Heading5>
        <p>20px/164%</p>
      </Item>
      <Item>
        <Paragraph>Paragraph desktop</Paragraph>
        <p>16px/172%</p>
      </Item>
      <Subheading>Mobile</Subheading>
      <Item>
        <Heading1Mobile>Heading 1 mobile</Heading1Mobile>
        <p>29px/148%</p>
      </Item>
      <Item>
        <Heading2Mobile>Heading 2 mobile</Heading2Mobile>
        <p>26px/164%</p>
      </Item>
      <Item>
        <Heading3Mobile>Heading 3 mobile</Heading3Mobile>
        <p>23px/164%</p>
      </Item>
      <Item>
        <Heading4Mobile>Heading 4 mobile</Heading4Mobile>
        <p>20px/164%</p>
      </Item>
      <Item>
        <Heading5Mobile>Heading 5 mobile</Heading5Mobile>
        <p>18px/164%</p>
      </Item>
      <Item>
        <ParagraphMobile>Paragraph mobile</ParagraphMobile>
        <p>16px/172%</p>
      </Item>
    </>
  )
}

export default Typography
